import React, { Component } from "react";
import PropTypes from "prop-types";
import { v4 } from "uuid";
import classcat from "classcat";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import alternateCountryTranslations from "infrastructure/translate/alternateCountyTranslations";
import CircleButton from "../../commons/CircleButton";
import { hideModal } from "../../../../usecases/commons/hide-modal";
import { translate as t } from "../../../../infrastructure/translate/localization";
import authClient from "../../../auth/Auth";
import { showIFeelFeature } from "../../../../infrastructure/chosen-company";

import { downloadEmployeeAdjustment } from "../../../../usecases/employee-detail/download-employee-adjustment";
import { downloadNovationContracts } from "../../../../usecases/employees/download-novation-contracts";
import { removeActiveEmployees } from "../../../../usecases/employees/remove-active-employees";

import "./show-delete-employees-modal.scss";
import { MonetaryAmount } from "../../../domain/monetary-amount";

class ShowDeleteEmployeesModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fundsOption: "keep",
      accumulatedOption: "keep",
      confirmed: false,
    };
  }

  handledRemoveActiveEmployees = async () => {
    const { employee, forceRefresh, page } = this.props;
    const { fundsOption, accumulatedOption } = this.state;

    await removeActiveEmployees({
      employeeId: employee.id,
      allowance: fundsOption,
      accumulated: accumulatedOption,
      forceRefresh,
      currentPage: page,
    });
    this.onClose({ isDeleted: true });
  };

  onClose = ({ isDeleted } = { isDeleted: false }) => {
    const { onFinish } = this.props;
    if (onFinish) onFinish({ isDeleted });
    hideModal();
  };

  render() {
    const {
      employee,
      adjustments,
      pendingPayment,
      totalCardFunds,
      totalHistoryOfFunds,
      totalAccumulated,
      totalHistoryOfAccumulated,
      country,
    } = this.props;
    const { confirmed, fundsOption, accumulatedOption } = this.state;
    const hasFunds = totalCardFunds > 0;
    const hasAccumulated = totalAccumulated > 0;
    const companyId = authClient.getCompanyId();

    return (
      <div className="modal-container">
        <CircleButton
          className="primary close-modal"
          icon="times"
          handlerClick={() => this.onClose()}
        />
        <div className="modal-content">
          <div className="modal-offboarding">
            <div className="modal-title">
              <p className="title">{`${employee.name} ${employee.surname}`}</p>
            </div>
            <p>{t("employees-section.consumptions-employee")}</p>
          </div>

          <div className="modal-offboarding">
            <div className="separate-line" />
            <div className="payroll">
              <div className="payroll-group">
                <div className="payroll-section">
                  <h3>{t("benefits-section.meal-benefit.meal")}</h3>
                  <div className="payroll-section-detail">
                    <span>{t("common-messages.flex")}:</span>
                    <span>{adjustments.mealsFromSalary} €</span>
                  </div>
                  <div className="payroll-section-detail">
                    <span>{t("common-messages.social-benefit")}:</span>
                    <span>{adjustments.companyGivenBenefits} €</span>
                  </div>
                </div>

                <div className="payroll-section">
                  <h3>{t("benefits-section.nursery-benefit.nursery")}</h3>
                  <div className="payroll-section-detail">
                    <span>{t("common-messages.flex")}:</span>
                    <span>{adjustments.childcareFromSalary} €</span>
                  </div>
                  <div className="payroll-section-detail">
                    <span>{t("common-messages.social-benefit")}:</span>
                    <span>{adjustments.companyGivenNurseryBenefits} €</span>
                  </div>
                  <div className="payroll-section-detail">
                    <span>{t("common-messages.not-exempt")}:</span>
                    <span>{adjustments.nurseryFromFlexNotExempt} €</span>
                  </div>
                </div>
              </div>

              <div className="payroll-group">
                <div className="payroll-section">
                  <h3>{t("benefits-section.transport-benefit.transport")}</h3>
                  <div className="payroll-section-detail">
                    <span>{t("common-messages.flex")}:</span>
                    <span>{adjustments.transportFromSalary} €</span>
                  </div>
                  <div className="payroll-section-detail">
                    <span>{t("common-messages.social-benefit")}:</span>
                    <span>{adjustments.companyGivenTransportBenefits} €</span>
                  </div>
                </div>

                <div className="payroll-section">
                  <h3>
                    {showIFeelFeature(companyId)
                      ? t("benefits-section.ifeel-benefit.ifeel")
                      : alternateCountryTranslations(
                          country,
                          "health-insurance"
                        )}
                  </h3>
                  <div className="payroll-section-detail">
                    <span>{t("common-messages.flex")}:</span>
                    <span>{adjustments.healthInsuranceFromSalary} €</span>
                  </div>
                  <div className="payroll-section-detail">
                    <span>{t("common-messages.social-benefit")}:</span>
                    <span>
                      {adjustments.companyGivenHealthInsuranceBenefits} €
                    </span>
                  </div>
                  <div className="payroll-section-detail">
                    <span>{t("common-messages.not-exempt")}:</span>
                    <span>
                      {adjustments.healthInsuranceFromFlexNotExempt} €
                    </span>
                  </div>
                </div>
              </div>

              <div className="payroll-group">
                <div className="payroll-section">
                  <h3>{t("benefits-section.education-benefit.education")}</h3>
                  <div className="payroll-section-detail">
                    <span>{t("common-messages.flex")}:</span>
                    <span>{adjustments.educationFromSalary} €</span>
                  </div>
                  <div className="payroll-section-detail">
                    <span>{t("common-messages.social-benefit")}:</span>
                    <span>{adjustments.companyGivenEducationBenefits} €</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="separate-line" />
            <div className="payroll-section">
              <h3>{t("employees-section.pending-payments")}</h3>
              <span className="advice">
                {t("employees-section.pending-payments-info")}
              </span>
              {pendingPayment?.length ? (
                pendingPayment.map((payment) => (
                  <div key={v4()} className="payroll-section-detail">
                    <span>{payment.date}</span>
                    <span>{payment.concept}</span>{" "}
                    <span>{payment.amount} €</span>
                    <span>
                      {t(`v2.common.benefit-type.${payment.category}`)}
                    </span>
                  </div>
                ))
              ) : (
                <div className="payroll-section-detail">
                  <span>{t("common-messages.none")}</span>
                </div>
              )}
              <div className="separate-line" />
            </div>

            <div className="payroll-section">
              <h3>{t("employees-section.download-information")}</h3>
              <span className="advice">
                {t("employees-section.download-information-tip")}
              </span>
              <div className="cob-btn-group">
                <div className="cob-btn-group">
                  <button
                    type="button"
                    className="cob-link"
                    onClick={() => downloadEmployeeAdjustment(employee)}
                  >
                    <FontAwesomeIcon icon="download" />
                    <span> {t("employees-section.download-consumptions")}</span>
                  </button>
                </div>
                <div className="cob-btn-group">
                  <button
                    type="button"
                    className="cob-link"
                    disabled={!employee.termsAndConditions}
                    onClick={() =>
                      downloadNovationContracts(
                        employee.termsAndConditions.idNovationContract,
                        employee.legalId
                      )
                    }
                  >
                    <FontAwesomeIcon icon="download" />
                    <span>
                      {" "}
                      {t("upload-employees-section.download-contract")}
                    </span>
                  </button>
                </div>
              </div>
              <div className="separate-line" />
            </div>
            {totalCardFunds > 0 && (
              <div className="payroll-section">
                <h3>{t("employees-section.funds-balance")}:</h3>
                <span className="advice">
                  {t("employees-section.funds-balance-info", {
                    totalCardFunds: MonetaryAmount.of(
                      totalCardFunds
                    ).prettifyMoney({}),
                    totalHistoryOfFunds,
                  })}
                </span>
                <div className="cob-btn-group">
                  <div className="cob-radio-button-check">
                    <div
                      className="radio-check"
                      onClick={() => this.setState({ fundsOption: "recover" })}
                      role="presentation"
                    >
                      <div
                        className={classcat([
                          "check",
                          { active: fundsOption === "recover" },
                        ])}
                      />
                      <p className="description">
                        {t("employees-section.withdraw-funds")}
                      </p>
                    </div>
                    <div
                      className="radio-check"
                      onClick={() => this.setState({ fundsOption: "keep" })}
                      role="presentation"
                    >
                      <div
                        className={classcat([
                          "check",
                          { active: fundsOption === "keep" },
                        ])}
                      />
                      <p className="description">
                        {t("employees-section.keep-funds")}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="separate-line" />
              </div>
            )}
            {totalAccumulated > 0 && (
              <div className="payroll-section">
                <h3>{t("employees-section.accumulated-balance")}:</h3>
                <span className="advice">
                  {t("employees-section.accumulated-balance-info", {
                    totalAccumulated: MonetaryAmount.of(
                      totalAccumulated
                    ).prettifyMoney({}),
                    totalHistoryOfAccumulated,
                  })}
                </span>
                <div className="cob-btn-group">
                  <div className="cob-radio-button-check">
                    <div
                      className="radio-check"
                      onClick={() =>
                        this.setState({ accumulatedOption: "recover" })
                      }
                      role="presentation"
                    >
                      <div
                        className={classcat([
                          "check",
                          { active: accumulatedOption === "recover" },
                        ])}
                      />
                      <p className="description">
                        {t("employees-section.withdraw-funds")}
                      </p>
                    </div>
                    <div
                      className="radio-check"
                      onClick={() =>
                        this.setState({ accumulatedOption: "keep" })
                      }
                      role="presentation"
                    >
                      <div
                        className={classcat([
                          "check",
                          { active: accumulatedOption === "keep" },
                        ])}
                      />
                      <p className="description">
                        {t("employees-section.keep-funds")}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="separate-line" />
              </div>
            )}
            <div className="cob-btn-group">
              <div
                className="cob-checkbox"
                onClick={() => this.setState({ confirmed: !confirmed })}
                role="presentation"
              >
                {confirmed && <FontAwesomeIcon icon="check" />}
              </div>
              <p>
                {t("employees-section.delete-confirm", {
                  employee: `${employee.name} ${employee.surname}`,
                })}
              </p>
            </div>
            <div className="separate-line" />
          </div>

          <div className="cob-btn-group right-group">
            <button
              type="button"
              className="cob-btn btn-primary-outline"
              onClick={() => this.onClose()}
            >
              {t("actions.cancel")}
            </button>
            <button
              type="button"
              className="cob-btn btn-primary-outline"
              disabled={
                !confirmed ||
                (hasFunds && fundsOption === "") ||
                (hasAccumulated && accumulatedOption === "") ||
                (!confirmed && !hasFunds && !hasAccumulated)
              }
              onClick={this.handledRemoveActiveEmployees}
            >
              {t("actions.delete")}
            </button>
          </div>
        </div>
      </div>
    );
  }
}

ShowDeleteEmployeesModal.defaultProps = {
  forceRefresh: false,
  page: 1,
  country: "ES",
};
ShowDeleteEmployeesModal.propTypes = {
  employee: PropTypes.object.isRequired,
  forceRefresh: PropTypes.bool,
  page: PropTypes.number,
  adjustments: PropTypes.object.isRequired,
  pendingPayment: PropTypes.array.isRequired,
  totalCardFunds: PropTypes.number.isRequired,
  totalHistoryOfFunds: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  totalAccumulated: PropTypes.number.isRequired,
  totalHistoryOfAccumulated: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  onFinish: PropTypes.func.isRequired,
  country: PropTypes.string,
};

export default ShowDeleteEmployeesModal;
